import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { auth } from "../firebase/firebaseDb.js";
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { sendEmailVerification } from "firebase/auth";

const Header = () => {
  const modalRef = useRef();
  const { t } = useTranslation();

  const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('user_info')));
  const [firebaseUserInfo, setFirebaseUserInfo] = useState(JSON.parse(localStorage.getItem('firebase_user')));
  const [websiteLoadState, setWebsiteLoadState] = useState('loaded');
  const [credit, setCredit] = useState(0);

  useEffect(() => {
    getUserInfo();
  }, [credit]);

  const logoutUser = async () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const getUserInfo = async () => {
    setWebsiteLoadState('loading');
    const payload = { user_id: firebaseUserInfo.uid };
    axios.post(process.env.REACT_APP_PHP_API_URL + "zuribuildAPI/login-user.php", payload, {
      headers: { "Content-Type": "application/json" }
    })
    .then((res) => {
      localStorage.setItem('user_info', JSON.stringify(res.data[0]));
      setCredit(JSON.parse(localStorage.getItem('user_info')).credit);
    })
    .catch((err) => {
      setWebsiteLoadState("loaded");
      console.error("Error:", err.message);
      toast.error(err.message, { position: 'bottom-right' });
    });
  };

  return (
    <>
      <style>{`
        body {
          margin: 0;
          font-family: Arial, sans-serif;
          background-color: #fff;
          color: #000;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100vw;
          padding: 20px;
          position: fixed;
          z-index: 1000;
          box-sizing: border-box;
          background: var(--glass);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 2px solid rgba(128, 0, 128, 0.1);
        }

        .logo {
          font-size: 26px;
          font-weight: 800;
          color: var(--secondary-red);
          letter-spacing: -1px;
          text-decoration: none;
        }

        .step { font-size: 14px; font-weight: 550; color: #555; }
        .modal-backdrop { background-color: rgba(0, 0, 0, 0.3) !important; }
        .btn { width: 100%; height: 50px; border-radius: 25px; border: none; background-color: purple; color: white; font-size: 16px; cursor: pointer; transition: 0.3s; }
        .btn:hover { background-color: #5a0e8f; }

        .dropdown-menu {
          border: 1px solid rgba(0,0,0,0.08) !important;
          border-radius: 14px !important;
          box-shadow: 0 8px 32px rgba(0,0,0,0.12) !important;
          padding: 6px !important;
          min-width: 230px !important;
          margin-top: 8px !important;
          font-family: 'Inter', -apple-system, sans-serif !important;
        }

        .dropdown-item {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          padding: 9px 12px !important;
          border-radius: 9px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #111 !important;
          font-family: 'Inter', -apple-system, sans-serif !important;
          transition: background 0.12s ease !important;
          text-decoration: none !important;
          line-height: 1.4 !important;
        }

        .dropdown-item:hover { background: #f4f0ff !important; color: #7C3AED !important; }
        .dropdown-item:hover i { color: #7C3AED !important; }
        .dropdown-item i { font-size: 15px; color: #888; width: 18px; text-align: center; flex-shrink: 0; transition: color 0.12s ease; }
        .dropdown-item.logout-item { color: #e11d48 !important; }
        .dropdown-item.logout-item i { color: #e11d48 !important; }
        .dropdown-item.logout-item:hover { background: #fff1f2 !important; }
        .dropdown-divider { margin: 4px 8px !important; border-color: #f0f0f0 !important; }

        .dropdown-user-info { padding: 8px 12px; border-bottom: 1px solid #f0f0f0; margin-bottom: 4px; }
        .dropdown-user-name { margin: 0; font-size: 13px; font-weight: 700; color: #111; font-family: 'Inter', sans-serif; }
        .dropdown-user-email { margin: 0; font-size: 11px; color: #aaa; font-family: 'Inter', sans-serif; }

        .badge-new {
          background: linear-gradient(135deg, #f59e0b, #f97316);
          color: white; font-size: 9px; font-weight: 700;
          padding: 2px 6px; border-radius: 6px;
          margin-left: auto; letter-spacing: 0.3px;
        }

        .lang-row { display: flex; align-items: center; gap: 4px; padding: 6px 12px 4px; }
        .lang-btn {
          display: flex; align-items: center; gap: 5px;
          background: #f5f5f5; border: none; border-radius: 8px;
          padding: 5px 10px; font-size: 12px; font-weight: 600;
          cursor: pointer; color: #555; transition: background 0.12s;
          font-family: 'Inter', sans-serif;
        }
        .lang-btn:hover { background: #ede9fe; color: #7C3AED; }

        .fade { padding-bottom:70px; margin-top:70px; opacity: 0; transform: translateY(10px); animation: fadeIn 0.6s ease forwards; }
        @keyframes fadeIn { to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 767px) {
          .dropdown-item { font-size: 15px !important; padding: 11px 12px !important; }
        }
      `}</style>

      <header className="header">

        {/* Logo */}
        <Link to="/dashboard" style={{ textDecoration: 'none' }}>
          <div className="logo">
            <img src="/zuribuild.png" style={{ width: '40px' }} alt="logo" />
            ZuriBuild
          </div>
        </Link>

        {/* Right side */}
        <div className="step">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

            {/* Credit badge — OUTSIDE .dropdown */}
            <button
              type="button"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                color: 'white',
                border: 'none',
                borderRadius: '20px',
                padding: '5px 12px',
                fontSize: '13px',
                fontWeight: '700',
                cursor: 'default',
                boxShadow: '0 2px 8px rgba(245,158,11,0.3)',
                whiteSpace: 'nowrap',
                width: 'auto',
                height: 'auto',
              }}
            >
              <i className="bi bi-star-fill" style={{ fontSize: 12 }} />
              {credit}
            </button>

            {/* Dropdown — ONLY avatar button + ul inside */}
            <div className="dropdown">

              {/* Avatar toggle button */}
              <button
                className="btn btn-secondary gear-fill"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #7C3AED, #a855f7)',
                  color: 'white',
                  border: 'none',
                  fontWeight: '700',
                  fontSize: '15px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(124,58,237,0.35)',
                  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                  flexShrink: 0,
                  padding: 0,
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 4px 14px rgba(124,58,237,0.45)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(124,58,237,0.35)';
                }}
              >
                {firebaseUserInfo.displayName.charAt(0).toUpperCase()}
              </button>

              {/* Dropdown ul — direct sibling of toggle button */}
              <ul className="dropdown-menu dropdown-menu-end">

                <li>
                  <div className="dropdown-user-info">
                    <p className="dropdown-user-name">{firebaseUserInfo.displayName}</p>
                    <p className="dropdown-user-email">{firebaseUserInfo.email}</p>
                  </div>
                </li>

                <li>
                  <Link className="dropdown-item" to="/dashboard">
                    <i className="bi bi-grid-fill" />
                    {t("header.main_menu")}
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/profile">
                    <i className="bi bi-person-fill" />
                    {t("header.profile_information")}
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/payment-history">
                    <i className="bi bi-receipt" />
                    {t("header.payment_history")}
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/credit">
                    <i className="bi bi-lightning-charge-fill" />
                    {t("header.topup_credit")}
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/credit-code">
                    <i className="bi bi-gift-fill" />
                    {t("header.credit_code_history")}
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/domain-registration">
                    <i className="bi bi-globe2" />
                    {t("header.get_a_domain")}
                    <span className="badge-new">NEW</span>
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/customer-support">
                    <i className="bi bi-headset" />
                    {t("header.customer_support")}
                  </Link>
                </li>

                <li><hr className="dropdown-divider" /></li>

                <li>
                  <div className="lang-row">
                    <button className="lang-btn" onClick={() => i18n.changeLanguage("en")}>
                      <img src="/images/en.png" style={{ width: 16, height: 16 }} alt="EN" /> EN
                    </button>
                    <button className="lang-btn" onClick={() => i18n.changeLanguage("fr")}>
                      <img src="/images/fr.png" style={{ width: 16, height: 16 }} alt="FR" /> FR
                    </button>
                  </div>
                </li>

                <li><hr className="dropdown-divider" /></li>

                <li>
                  <a className="dropdown-item logout-item" href="#"
                    data-bs-toggle="modal" data-bs-target="#exampleModal2">
                    <i className="bi bi-box-arrow-right" />
                    {t("header.logout")}
                  </a>
                </li>

              </ul>
            </div>

          </div>
        </div>
      </header>

      {/* Logout modal */}
      <div className="modal fade" id="exampleModal2" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel" style={{ fontWeight: 'bold' }}>
                {t("header.logout")}
              </h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              {t("header.are_you_sure")}
            </div>
            <div className="modal-footer dropdown-item">
              <button onClick={logoutUser} style={{ background: 'red', fontFamily: 'Segoe ui', fontWeight: '400' }}
                type="button" className="btn btn-primary">
                {t("header.logout")}
              </button>
              <button style={{ background: 'black' }} type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                {t("header.cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;